import {
  AnalyticsEventAction,
  AnalyticsEventType,
} from '@th/shared/src/types/AnalyticsEvent';
import Link from 'next/link';
import React from 'react';
import { Agent } from '@th/shared/src/types/Agent';
import logEvent from '../helpers/mutations/logEvent';

type Props = {
  agent: Agent;
};

const DEFAULT_BROKERAGE_TEXT =
  'Ben Amirghassemi | 647-699-3274 | Sutton Group-Admiral Realty Inc. Brokerage';

export default function MapFooter({ agent }: Props) {
  const agentOrBrokerageName = agent
    ? `${agent.legalName}, Broker`
    : DEFAULT_BROKERAGE_TEXT;

  return (
    <div className="hidden md:flex flex-row justify-between items-center py-2 px-4">
      <div className="flex-1 flex-row">
        {/*<Link href={'/marketstats'} className="text-gray-600 mr-10">*/}
        {/*  Market Stats*/}
        {/*</Link>*/}
        <Link href={'/privacy-policy'} className="text-gray-600 mr-10">
          Privacy Policy
        </Link>
        <Link href={'/terms-of-service'} className="text-gray-600 mr-10">
          Terms of Service
        </Link>
      </div>
      <div className="flex flex-row justify-center">
        <Link href={'/download'}>
          <button
            type={'button'}
            className={'btn uppercase hover:bg-darkGray'}
            onClick={() => {
              logEvent({
                action:
                  AnalyticsEventAction.clicked_download_button_in_map_footer,
                type: AnalyticsEventType.download_button_click,
              });
            }}
          >
            Download App
          </button>
        </Link>
      </div>
      <div className="flex-1 flex-col content-end">
        <div className="text-xxs text-gray-600 text-end">
          Data is provided courtesy of Toronto Regional Real Estate Board
        </div>
        <div className="text-xxs text-gray-600 text-end">
          {agentOrBrokerageName}
        </div>
      </div>
    </div>
  );
}
